import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Page } from "src/app/model/Page";
import { PaymentSettlementModel } from "src/app/model/PaymentSettlementModel";
import { PaymentReconciliationService } from "src/app/services/payment-reconciliation.service";
import { MasterService } from "src/app/services/master.service";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";

@Component({
  selector: "app-secure-payment-settlement",
  templateUrl: "./payment-settlement.component.html",
  styleUrls: ["./payment-settlement.component.scss"],
})
export class PaymentSettlementComponent implements OnInit {
  lotteryList: PaymentSettlementModel[] = [];
  loaded: boolean = false;
  loaded1: boolean = false;
  statusList: any[] = [
    { name: "Partial Payment Credited", value: "PARTIAL_PAYMENT" },
    {
      name: "Full Payment Credited Settlement Not Done",
      value: "FULL_PAYMENT",
    },
    {
      name: "Reconciliation Done With TDS",
      value: "RECONCILIATION_DONE_WITH_TDS",
    },
    {
      name: "Reconciliation Done Without TDS",
      value: "RECONCILIATION_DONE_WITHOUT_TDS",
    },
    {
      name: "Approved By Account Officer",
      value: "ACCOUNT_OFFICER_APPROVED",
    },
    // { name: "TDS", value: "TDS" },
  ];

  selectedLotteryCode: string | null = null;
  page: Page<PaymentSettlementModel>;
  dataSource: MatTableDataSource<PaymentSettlementModel> =
    new MatTableDataSource();
  // form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  refreshDate: string;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    // "transactionId",
    "applicantName",
    "schemaCode",
    "paymentStatus",
    // "transactionStatus",
    // "transactionDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private _snackBar: MatSnackBar,

    private route: ActivatedRoute,

    private paymentSettlementService: PaymentSettlementService
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-payment-settlement-filterText"),
        [Validators.required, Validators.minLength(3)]
      ),
      lotterysName: new FormControl(null),
      // paymentStatus: new FormControl(null),
      paymentStatus: new FormControl(
        localStorage.getItem("payment-view-paymentStatus")
      ),
    });
    this.filterForm.controls["filterText"].setValue(null);

    this.route.params.subscribe((params: Params) => {
      this.paymentSettlementService.getLotteryName().subscribe(
        (data: any) => {
          this.loaded1 = true;

          if (data.status === "SUCCESS") {
            this.lotteryList = data.lotteryList;

            this.filterForm.patchValue({
              lotterysName: this.lotteryList.find(
                (l) =>
                  l.key === +localStorage.getItem("payment-view-lotterysName")
              ),
            });
          } else {
            this.paymentSettlementService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.paymentSettlementService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );
    });

    this.loadData();
  }
  onLotteryChange(value: any) {
    this.lotteryEventId = value.key;
    localStorage.setItem(
      "payment-view-lotterysName",
      this.lotteryEventId.toString()
    );
    this.loadData();
  }
  onStatusChange(value: any) {
    this.statusId = value;
    console.log("this.statusId = ", this.statusId);
    this.loaded = false;
    localStorage.setItem("payment-view-paymentStatus", this.statusId);
    this.loadData();
  }
  loadData() {
    this.loaded = false;
    if (this.lotteryEventId !== null) {
      this.paymentSettlementService
        .getAccountOfficerConfirmedList(
          localStorage.getItem("payment-view-lotterysName"),

          localStorage.getItem("payment-view-paymentStatus"),
          this.currentPage,
          this.pageSize,
          this.filterForm.value.filterText
        )
        .subscribe(
          (data: any) => {
            this.loaded = true;
            console.log("Page ", data.page);
            this.page = data.page;
            this.refreshDate = data.refreshDate;
            console.log(
              "this.lastRefreshDate = data.lastRefreshDate;",
              this.refreshDate
            );
            if (data.page.content[0] !== null) {
              this.dataSource = new MatTableDataSource(data.page.content);
            } else {
              this.dataSource = new MatTableDataSource<PaymentSettlementModel>(
                []
              );
            }
            console.log("this.dataSource ", this.page);
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = data.page.totalElements;
            });
            this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            this.isSearchDisabled = false;
          }
        );
    } else {
      this.paymentSettlementService.errorToast("Please select Lottery");
    }
  }

  resetFilter() {
    // window.location.reload();
    this.filterForm.controls["lotterysName"].setValue(null);
    this.filterForm.controls["paymentStatus"].setValue(null);
    this.filterForm.controls["filterText"].setValue(null);
    // this.filterForm.controls["status"].setValue(null);
    // this.filterForm.controls["lotterysName"].setValue(null);

    this.page = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
  }
  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.dataSource = null;
      this.pageSize = 0;
      this.currentPage = 0;
      localStorage.setItem(
        "app-secure-payment-settlement-filterText",
        this.filterForm.value.filterText
      );

      this.onLoad();
    } else {
      this._snackBar.open(
        "Lottery Name and Application Number is Required ",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }
  onLoad() {
    this.loaded = false;
    this.paymentSettlementService

      .getAccountOfficerFilterList(
        localStorage.getItem("payment-view-lotterysName"),

        this.filterForm.value.paymentStatus,
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (data: any) => {
          this.page = data.page;
          this.refreshDate = data.refreshDate;
          if (data.page.content && data.page.content.length !== 0) {
            this.dataSource = new MatTableDataSource(data.page.content);
          } else {
            this._snackBar.open(
              "Please Enter Valid Application Number ",
              "Close",
              {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
              }
            );
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.page.totalElements;
          });
          this.isSearchDisabled = false;
          this.loaded = true;
        },
        (error) => {
          console.log(error);
          this.loaded = false;
          this.isSearchDisabled = false;
        }
      );
  }

  // ngAfterViewInit(): void {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}
